export default __webpack_public_path__ + "static/media/a008-C.e63638e2.svg";